
import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type { ServiceResponse, UUID } from '@dopomogai/types';
import type { SecretCreateRequest, SecretRotateRequest, SecretResponse, SecretUsageResponse } from '@dopomogai/types';

export const secretsService = {
  list: (): ServiceResponse<SecretResponse[]> =>
    getApiClient().get<SecretResponse[]>('/secrets')
      .then(r => r.data)
      .catch(err => handleApiError(err, 'listing secrets')),

  create: (payload: SecretCreateRequest): ServiceResponse<SecretResponse> =>
    getApiClient().post<SecretResponse>('/secrets', payload)
      .then(r => r.data)
      .catch(err => handleApiError(err, 'creating secret')),

  rotate: (secretId: UUID, payload: SecretRotateRequest): ServiceResponse<SecretResponse> =>
    getApiClient().patch<SecretResponse>(`/secrets/${secretId}`, payload)
      .then(r => r.data)
      .catch(err => handleApiError(err, 'rotating secret')),

  delete: (secretId: UUID): ServiceResponse<void> =>
    getApiClient().delete(`/secrets/${secretId}`)
      .then(() => undefined)
      .catch(err => handleApiError(err, 'deleting secret')),

  getUsage: (secretId: UUID): ServiceResponse<SecretUsageResponse> =>
    getApiClient().get<SecretUsageResponse>(`/secrets/${secretId}/usage`)
      .then(r => r.data)
      .catch(err => handleApiError(err, 'getting secret usage')),
};